import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import DialogLayout from "container/Dialogs/DialogLayout";
import GoogleAd from "./AdComponent";
import { getRewartPrompts, userDashboardData } from "container/api";
import StopModal from "./StopModal";
// import VideoAd from "./VideoAd";

const AdModal = ({
  open,
  setOpen,
  setOpenCongratulationsModal,
  countdown,
  setCountdown,
  setIsStopModalOpen,
  isStopModalOpen,
}) => {
  const [adLoading, setAdLoading] = useState(true);
  const remainingPrompts = useSelector((state) => state.chat.remainingPrompts);
  const dispatch = useDispatch();

  const fetchRewardPrompts = async () => {
    try {
      const { data } = await getRewartPrompts();
      if (data.status === 200) {
        setAdLoading(true)
        const dashboardData = await userDashboardData();
        dispatch.chat.setRemainingPrompts(
          dashboardData?.data?.remaining_prompts?.remaningprompts
        );
      }
    } catch (error) {
      console.error("Failed to fetch reward or dashboard prompts:", error);
    }
  };

  const handleSkipAd = async () => {
    setIsStopModalOpen(false);
    // setOpenCongratulationsModal(true);
    await fetchRewardPrompts();
  };

  useEffect(() => {
    if (remainingPrompts === 0 && open && adLoading) {
      const loadingTimeout = setTimeout(() => {
        setAdLoading(false);
      }, 4000);
  
      return () => clearTimeout(loadingTimeout);
    }
  }, [remainingPrompts, open, adLoading]);
  
  useEffect(() => {
    if (remainingPrompts === 0 && open && !adLoading) {
      const timer = setInterval(() => {
        setCountdown((prevCount) => {
          if (prevCount <= 1) {
            clearInterval(timer);
            setIsStopModalOpen(true); // Show StopModal
            setOpen(false); // Close AdModal
            return 15; // Reset countdown
          }
          return prevCount - 1;
        });
      }, 1000);
  
      return () => clearInterval(timer);
    }
  }, [remainingPrompts, open, adLoading, setCountdown, setIsStopModalOpen, setOpen]);
  

  return (
    <>
      <DialogLayout open={open}>
        <StyledModal>
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="countdown">
                {adLoading ? (
                  <span>Ad is loading, please wait...</span>
                ) : (
                  <>
                    This ad will finish in <b>{countdown}</b> seconds
                  </>
                )}
              </div>
              <span className="subtitle">
                When finished you will receive 5 free prompts
              </span>
              <div className="flex justify-center">
                <GoogleAd
                  remainingPrompts={remainingPrompts}
                  onAdLoaded={() => setAdLoading(false)}
                />
              </div>
            </div>
          </div>
        </StyledModal>
      </DialogLayout>
      {isStopModalOpen && (
        <StopModal
          onContinue={handleSkipAd}
          onClose={() => setIsStopModalOpen(false)}
          isStopModalOpen={isStopModalOpen}
          fetchRewardPrompts={fetchRewardPrompts}
        />
      )}
    </>
  );
};

export default AdModal;

const StyledModal = styled.div`
  --bs-modal-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal-dialog {
    max-width: 500px;
    width: 100%;
    z-index: 1000000000000;
  }

  .modal-content {
    background: var(--darkgrey);
    border-radius: 15px;
    padding: 20px;
    text-align: center;
    overflow: hidden;
  }

  .countdown {
    font-weight: medium;
    font-size: 24px;
    color: var(--primary);
    margin-bottom: 15px;
    min-width: 400px;
  }
  .subtitle {
    color: #afb7c0;
    ${"" /* max-width: 34ch; */}
    text-align: center;
    margin-block: 4px 20px;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    z-index: 100000000000000;
  }
`;
